import React, { useState } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UserLogo from '../../../../images/rewampimages/user.png'
import DocLogo from '../../../../images/rewampimages/document.png'
import EditLogo from '../../../../images/rewampimages/edit.png'
import { MarkInsuraceStatusById, UploadEditInsuranceDocs } from '../AdminActionCreator.component';
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'

export default function InsuranceDetails({ handleType, detailData }) {
    const [tab, setTab] = useState("basic");
    const [loader, setLoader] = useState(false)
    const [selectedDocument, setSelectedDocument] = useState([])
    const [showMarkStatus, setShowMarkStatus] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: '' })
    const [showDocumnetPopup, setShowDocumentPopup] = useState({
        show: false, docs: {
            aadhaar: "",
            pan: "",
            rc: "",
            invoice: "",
            insurance_certificate: "",
            challan: "",
            form22: "",
        }
    })
    const handleDocument = (e) => {
        const value = e.target.value;
        if (!value) return;

        setSelectedDocument((prev) =>
            prev.includes(value)
                // ? prev.filter((doc) => doc !== value)
                ? [...prev]
                : [...prev, value]
        );
    };

    const handleMarkStatus = (type) => {
        setLoader(true)
        MarkInsuraceStatusById(detailData?.userId, type, callback => {
            setLoader(false)
            setShowMarkStatus(false)
            if (callback?.status == 200 && callback?.message == "success") {
                setPopup({ show: true, popupStatus: 'Status Changed Successfully' })
            } else {
                setPopup({ show: true, popupStatus: 'Error Changing status' })
            }
            removePopup()

        })
    }

    const handleUrlName = (url) => {
        if (url == "aadhaarCardUrl" || url == "aadhaar") return "Aadhaar Card"
        else if (url == "panCardUrl" || url == "pan") return "Pan Card"
        else if (url == "invoiceUrl" || url == "invoice") return "Invoice"
        else if (url == "rcUrl" || url == "rc") return "RC"
        else if (url == "insuranceCertificateUrl" || url == "insurance_certificate") return "Insurance Certificate"
        else if (url == "form22Url" || url == "form22") return "Form 22"
        else if (url == "deliveryChallanUrl" || url == "challan") return "Delivery Challan"
        else return ""

    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    function downloadFile(url, fileName) {
        if (!url) {
            console.error('URL is required for download');
            return;
        }


        const urlParams = new URLSearchParams(url.split('?')[1]);
        const fileType = urlParams.get('type');
        const extension = fileType || url.split('.').pop().split('?')[0];

        console.log("Downloading:", `${fileName}.${extension}`);


        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.blob();
            })
            .then(blob => {

                const blobUrl = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = `${fileName}.${extension}`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(blobUrl);
            })
            .catch(error => {
                console.error('Download failed:', error);

                window.open(url, '_blank');
            });
    }

    const handleUploadDoc = (e, key) => {
        setShowDocumentPopup((prev) => ({
            ...prev,
            docs: {
                ...prev.docs,
                [key]: e.target.files[0]
            }
        }))
        if (e.target.files[0]) {
            UploadEditInsuranceDocsFn(key, e.target.files[0])
        }
    }


    const UploadEditInsuranceDocsFn = (type, file) => {
        setLoader(true)
        UploadEditInsuranceDocs(detailData?.userId, file, type, callback => {
            setLoader(false)
            const data = JSON.parse(callback)
            console.log("ca", callback, data)
            if (data?.message == "success" && data?.status == 200) {
                setPopup({ show: true, popupStatus: 'Document Uploaded Succesfully' })
            } else {
                setPopup({ show: true, popupStatus: 'Error Uploading Document' })
            }
            removePopup()
            setTimeout(() => {
                setShowDocumentPopup({
                    show: true, docs: {
                        aadhaar: "",
                        pan: "",
                        rc: "",
                        invoice: "",
                        insurance_certificate: "",
                        challan: "",
                        form22: "",
                    }
                })
            }, 1000)
        })
    }

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className='communitySection' style={{ marginTop: '20px' }}>
                <div className="container-fluid">
                    <ArrowBackIcon style={{ marginBottom: '15px', cursor: 'pointer', fontSize: '24px', color: '#000' }} onClick={() => handleType("list", "")} />

                    <div className="row">
                        <div className='edit-profile-menu col-xs-12'>
                            <div className='btn-group-tab'>
                                <div>
                                    <button className={tab == "basic" ? "active" : ""} onClick={() => setTab("basic")}>Basic Details</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    tab == "basic" ?

                        <div className="container-fluid details-new ">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className='details-body' style={{ boxShadow: 'grey 3px 3px 10px -8px', marginTop: '30px' }}>
                                        <div className="details-head">
                                            <div className="row">
                                                <div className="col-sm-9 col-xs-11">
                                                    <div style={{ marginTop: '6px' }}>
                                                        <img src={UserLogo} style={{ width: '20px' }} /> &nbsp;
                                                        <b style={{ marginTop: '14px' }}>Personal Information</b>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3 col-xs-1" style={{ textAlign: 'end' }}>
                                                    <b style={{ marginTop: '14px' }}>Status:  &nbsp;<span style={{ color: detailData?.status == "complete" ? "#127b12" : "red" }}>{detailData?.status?.charAt(0)?.toUpperCase() + detailData?.status?.slice(1)}</span></b>
                                                </div>

                                            </div>
                                        </div>
                                        <div style={{ padding: '10px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                            <div className="row" >
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Customer Name</label>
                                                    <p>{detailData?.customerName || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Email ID</label>
                                                    <p>{detailData?.emailId || ""}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Mobile No.</label>
                                                    <p>{detailData?.contactNumber || ""}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>D.O.B</label>
                                                    <p>{detailData?.dateOfBirth || ""}</p>
                                                </div>
                                            </div>
                                            <div className="row" >
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Aadhaar Number</label>
                                                    <p>{detailData?.aadhaarNumber || ""}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Pan Number</label>
                                                    <p>{detailData?.panNumber || ""}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Dealer Code</label>
                                                    <p>{detailData?.communityCode || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '10px' }}>
                                                    <label>Dealer Name</label>
                                                    <p>{detailData?.communityName || ""}</p>
                                                </div>
                                            </div>



                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <div className='details-body' style={{ boxShadow: 'grey 3px 3px 10px -8px', marginTop: '30px' }}>
                                        <div className="details-head">
                                            <div className="row">
                                                <div className="col-sm-11 col-xs-11">
                                                    <div style={{ marginTop: '6px' }}>
                                                        <img src={DocLogo} style={{ width: '20px' }} /> &nbsp;
                                                        <b style={{ marginTop: '14px' }}>Documents</b>
                                                    </div>
                                                </div>
                                                <div className="col-sm-1 col-xs-1" style={{ textAlign: 'end' }}>
                                                    <img src={EditLogo} style={{ cursor: 'pointer', width: '30px' }} onClick={() => setShowDocumentPopup({
                                                        show: true, docs: {
                                                            aadhaar: "",
                                                            pan: "",
                                                            rc: "",
                                                            invoice: "",
                                                            insurance_certificate: "",
                                                            challan: "",
                                                            form22: "",
                                                        }
                                                    })} />
                                                </div>

                                            </div>
                                        </div>
                                        <div style={{ padding: '20px', background: "#fff", borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                            <div className="row">
                                                <div className="col-sm-5">
                                                    <div>
                                                        <select className='form-control' style={{ width: '60%' }} onChange={(e) => handleDocument(e)}>
                                                            <option value={""}>Select Document</option>
                                                            <option value={"aadhaarCardUrl"}>Aadhaar Card</option>
                                                            <option value={"panCardUrl"}>Pan Card</option>
                                                            <option value={"invoiceUrl"}>Invoice</option>
                                                            <option value={"rcUrl"}>RC</option>
                                                            <option value={"insuranceCertificateUrl"}>Insurance Certificate</option>
                                                            <option value={"form22Url"}>Form 22</option>
                                                            <option value={"deliveryChallanUrl"}>Delivery Challan</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-7">
                                                    <div className='text-right'>
                                                        <button className='btn btn-primary' style={{ margin: "0 20px 0 0" }} onClick={() => setShowMarkStatus(!showMarkStatus)}>Mark Status</button>
                                                    </div>
                                                    {
                                                        showMarkStatus ?
                                                            <div className="mark-status">
                                                                <button className='btn -btn-default' style={{ background: "rgb(254, 236, 235)", color: "rgb(255, 68, 68)" }} onClick={() => handleMarkStatus("in progress")}>Incomplete</button>
                                                                <button className='btn -btn-default' style={{ background: "rgb(215, 251, 234)", color: "rgb(0, 200, 81)", marginTop: '10px', border: 'none' }} onClick={() => handleMarkStatus("complete")}>Complete</button>
                                                            </div>
                                                            : ''}
                                                </div>
                                            </div>


                                            <div className="row " style={{ marginTop: '30px' }}>
                                                {
                                                    selectedDocument && selectedDocument?.length > 0 ?
                                                        selectedDocument?.map((url, id) => {
                                                            // if(detailData[url] !== "" && detailData[url] !== undefined && detailData[url] !== null) return null
                                                            return (
                                                                <div className="col-sm-4 col-xs-12" key={id}>
                                                                    <div className='document-box' >
                                                                        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
                                                                            <a href={detailData[url]} target='_blank'>{handleUrlName(url)}</a>
                                                                            {
                                                                                detailData[url] !== "" && detailData[url] !== undefined && detailData[url] !== null ?
                                                                                    <span><i className='fa fa-download' style={{ cursor: 'pointer' }} onClick={() => downloadFile(detailData[url], handleUrlName(url))}></i></span>
                                                                                    : ''}
                                                                        </div>
                                                                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                                            {
                                                                                detailData[url] !== "" && detailData[url] !== undefined && detailData[url] !== null ?
                                                                                    detailData[url]?.includes("type=pdf") ?
                                                                                        <iframe width={"100%"} height={"300px"} src={detailData?.[url]} />
                                                                                        :
                                                                                        <img src={detailData?.[url]} width={"100%"} />
                                                                                    : ''}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {
                                showDocumnetPopup?.show ?
                                    <>
                                        <div className='details-new background-blur' style={{ background: 'rgba(5, 5, 5, 0.2)', color: "rgb(0, 0, 0)" }}>
                                            <div className="edit-box" style={{ width: '650px' }}>
                                                <div className="text-right" style={{ color: 'red' }}>
                                                    <i className='fa fa-times' style={{ fontSize: '20px', cursor: 'pointer' }} onClick={() => setShowDocumentPopup({
                                                        show: false, docs: {
                                                            aadhaar: "",
                                                            pan: "",
                                                            rc: "",
                                                            invoice: "",
                                                            insurance_certificate: "",
                                                            challan: "",
                                                            form22: "",
                                                        }
                                                    })}></i>
                                                </div>
                                                <h4><b>Edit Document</b></h4>
                                                {
                                                    showDocumnetPopup ? Object.entries(showDocumnetPopup?.docs)?.map(([key, value], id) => {
                                                        return (
                                                            <div className="row" style={{ marginTop: '10px' }} key={id}>
                                                                <div className='col-sm-4 col-xs-4' style={{ marginTop: '10px' }}>
                                                                    {handleUrlName(key)}
                                                                </div>
                                                                {console.log("value", value)}
                                                                <div className='col-sm-8 col-xs-8' >
                                                                    <label htmlFor={key} className='upload-file'>
                                                                        <i className='fa fa-cloud-upload' style={{ color: "rgb(38, 125, 255)" }}></i>
                                                                        &nbsp;&nbsp;{value !== "" && value !== null && value !== undefined ? value?.name : "Choose New File"}
                                                                    </label>
                                                                    <input className='display-none' id={key} type='file' accept='image/png , image/jpeg , application/pdf' onChange={(e) => handleUploadDoc(e, key)} />
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                        : ''}
                                            </div>
                                        </div>
                                    </>
                                    : ''}
                        </div>
                        : ''
                }
            </div>
        </>
    )
}
